<div class="min-h-screen flex flex-col bg-white overflow-x-hidden transition-[padding] duration-300"
	[ngClass]="shellClasses()">
	@let isMobile = screenWidth() <= 600;
	@let isOpen = menuOpen();
	@let isLtr = _storage.lang() === 'en';

	<!-- Desktop fixed sidebar: expanded (281) or collapsed icon rail (72) -->
	@if (!isMobile) {
	<aside
		[ngClass]="[
			isLtr ? 'left-0 border-r-3' : 'right-0 border-l-3',
			isOpen ? 'w-[281px]' : 'w-[72px]'
		]"
		class="border-teal-800 fixed inset-y-0 z-40 block bg-[var(--primary-color)] transition-[width] duration-300"
		aria-label="Sidebar">
		<app-sidebar
			[isMobile]="false"
			[open]="true"
			[collapsed]="!isOpen"
			(closed)="closeMenu()"
			(openLanguage)="openLanguagePopUp()"></app-sidebar>
	</aside>
	}

	<!-- Mobile curved header -->
	@if (isMobile) {
	<div class="overflow-y-auto bg-white scrollable">
		<div class="scroll-header">
			<div class="top-5 left-0 w-full flex items-center px-5 text-white">
				<div class="w-10 flex justify-start items-center shrink-0 relative">
					@if (header.isSideBarIcoShow()) {
					<button (click)="toggleMenu()"
						class="inline-flex items-center justify-center cursor-pointer"
						[attr.aria-label]="isOpen ? 'Close menu' : 'Open menu'"
						[attr.aria-expanded]="isOpen"
						type="button">
						<img
							[src]="isOpen ? 'assets/SVG/close-menu.svg' : 'assets/images/burger-icon.png'"
							alt=""
							class="w-6 h-6" />
					</button>
					} @else {
					<div class="w-6 h-6"></div>
					}
					<ng-container appPortalHost></ng-container>
				</div>

				<div class="flex-1 min-w-0 text-center px-3">
					<h1 [ngClass]="_storage.lang()==='ar'?'text-xl':'text-sm sm:text-2xl'"
						[title]="header.isNameShow()
                ? ('common.WELCOME' | translate:{ name: fullName })
                : (title() | translate)"
						class="font-semibold tracking-wide text-white truncate overflow-hidden whitespace-nowrap">
						{{
						header.isNameShow()
						? ('common.WELCOME' | translate:{ name: fullName })
						: (title() | translate)
						}}
					</h1>
				</div>

				<div class="w-10 flex justify-end shrink-0">
					@if (header.isNotificationIcoShow()) {
					<div class="flex flex-row gap-2 justify-start text-sm cursor-pointer dead-link">
						<img class="w-5 h-5" src="assets/SVG/notification-bell.svg" alt="Notification" />
					</div>
					} @else {
					<div class="w-5 h-5"></div>
					}
				</div>
			</div>
		</div>
	</div>

	<!-- Mobile drawer + backdrop -->
	@if (isOpen) {
	<div class="fixed inset-0 top-14 z-30 bg-black/30" (click)="closeMenu()" aria-hidden="true"></div>
	<aside
		[ngClass]="[
			isLtr ? 'left-0 rounded-r-[14px]' : 'right-0 rounded-l-[14px]',
			isLtr ? 'sidebar-slide-in-ltr' : 'sidebar-slide-in-rtl'
		]"
		class="fixed top-14 z-40 h-[calc(100vh-56px)] w-[200px] bg-[var(--primary-color)] overflow-y-auto shadow-xl"
		role="dialog"
		aria-modal="true"
		aria-label="Sidebar">
		<app-sidebar [isMobile]="true" [open]="true" (closed)="closeMenu()"
			(openLanguage)="openLanguagePopUp()"></app-sidebar>
	</aside>
	}
	}

	<!-- Desktop header -->
	@if (!isMobile) {
	<header
		class="sticky top-0 z-30 h-14 w-full bg-[var(--primary-color)] flex items-center justify-between p-3 md:p-4 lg:p-5 xl:p-6">
		<div class="flex flex-row justify-start gap-2 items-center">
			<button type="button" (click)="toggleMenu()"
				class="inline-flex items-center justify-center cursor-pointer"
				[attr.aria-label]="isOpen ? 'Close menu' : 'Open menu'"
				[attr.aria-expanded]="isOpen">
				<img
					[src]="isOpen ? 'assets/SVG/close-menu.svg' : 'assets/images/burger-icon.png'"
					alt=""
					class="w-6 h-6" />
			</button>
			<h1 class="text-base md:text-lg font-semibold tracking-wide text-white">
				{{ fullName }}
			</h1>
		</div>

		<div class="flex flex-row gap-3 justify-between">
			<div (click)="openLanguagePopUp()"
				class="flex flex-row gap-2 justify-start bg-[var(--primary-color)] px-3 py-1 text-sm rounded-lg cursor-pointer">
				<img src="assets/SVG/globe.svg" alt="" />
				<p class="text-white">{{ _storage.lang() === 'en' ? 'EN' : 'العربية' }}</p>
			</div>
		</div>
	</header>
	}

	<!-- Main Section -->
	<main [ngClass]="dynamicClasses()" class="transition-all duration-300">
		<app-global-loader />
		<router-outlet />
		<app-toast-container />
	</main>

	<!-- Mobile Footer -->
	@if (isMobile && isDashboard()) {
	<div class="fixed bottom-0 left-0 h-[70px] w-full bg-white p-4 flex justify-between items-center shadow-lg z-20">
		<div routerLink="/dashboard" class="flex flex-col items-center justify-center gap-1 cursor-pointer">
			<div class="w-[40px] h-[40px] rounded-full flex justify-center items-center">
				<img src="assets/images/bottom-bar/home.png" alt="Home" class="w-full h-full object-contain" />
			</div>
		</div>

		<div class="flex flex-col items-center justify-center gap-1 dead-link">
			<div class="w-[34px] h-[34px] rounded-full flex justify-center items-center">
				<img src="assets/images/bottom-bar/wallets.png" alt="Wallet" class="w-full h-full object-contain" />
			</div>
			<span class="text-black text-[11px]">{{ 'sidebar.WALLET' | translate }}</span>
		</div>

		<div class="flex flex-col items-center justify-center gap-1 dead-link">
			<div class="w-[34px] h-[34px] rounded-full flex justify-center items-center">
				<img src="assets/images/bottom-bar/cash-out.png" alt="Cash out" class="w-full h-full object-contain" />
			</div>
			<span class="text-black text-[11px]">{{ 'sidebar.CASH_OUT' | translate }}</span>
		</div>

		<div routerLink="/settings" class="flex flex-col items-center justify-center gap-1 cursor-pointer">
			<div class="w-[29px] h-[29px] rounded-full flex justify-center items-center">
				<img src="assets/images/bottom-bar/settings.png" alt="Settings" class="w-full h-full object-contain" />
			</div>
			<span class="text-black text-[11px]">{{ 'sidebar.SETTINGS' | translate }}</span>
		</div>
	</div>
	}

	<app-language-modal [isPopUpVisible]="isLangPopUpVisible"></app-language-modal>

	@if (_idleTime.isIdle()) {
	<app-popup (btnClick)="handleSessionExpired($event)" [isPopupVisible]="_idleTime.isIdle" [btnTxt]="'common.OKAY'"
		[headerTxt]="'common.SESSION_EXPIRE'" [contentTxt]="'common.YOUR_SESSION_EXPIRE'"></app-popup>
	}
</div>
